module.exports = __webpack_public_path__ + "static/media/img-scope2.7770f310.png";